import { render, staticRenderFns } from "./MsPopup.vue?vue&type=template&id=2b136fb8&scoped=true&lang=html"
import script from "./MsPopup.vue?vue&type=script&lang=js"
export * from "./MsPopup.vue?vue&type=script&lang=js"
import style0 from "./MsPopup.vue?vue&type=style&index=0&id=2b136fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b136fb8",
  null
  
)

export default component.exports